import { Box, Tab, Tabs } from "@mui/material"
import { useState } from "react";
import { ActividadesAcademicas } from "./ActividadesAcademicas";
import { ActividadesGestion } from "./ActividadesGestion";

interface Props{
    
}
export const AyudantiasAcademicas: React.FC<Props> = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };
    
    return (
        <Box>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                centered
            >
                <Tab
                label="Ayudantía de DOCENCIA"
                sx={{ fontWeight: "bold", color: "#243165", alignItems: "flex-start", textTransform: "none" }}
                />
                <Tab
                label="Ayudantía de GESTIÓN"
                sx={{ fontWeight: "bold", color: "#243165", alignItems: "flex-start", textTransform: "none"}}
                />
            </Tabs>

            <Box sx={{ flexGrow: 1, padding: 2 }}>
                {/* Aquí puedes mostrar el contenido según el tab seleccionado */}
                {tabIndex === 0 && (<ActividadesAcademicas />)}
                {tabIndex === 1 && (<ActividadesGestion />)}
            </Box>
        </Box>
        
    )

}